<div class="h-2 w-full rounded relative bg-white">
    <div class="rounded absolute z-10 w-0 top-0 left-0 h-full bg-secondary transition duration-500"
        [style.width]="progress + '%'">
    </div>
</div>